<template>
  <svg
    :id="uniqueId"
    :class="classnames"
    :fill="`currentColor`"
    :height="getHeight"
    :viewBox="`0 0 17 10`"
    :width="getWidth"
  >
    <path d="M16.703125,2.03083235 C16.703125,2.22091017 16.6751728,2.3914186 16.6192676,2.54236275 C16.5633623,2.6933069 16.4627344,2.84145357 16.3173808,2.98680719 L9.64232835,9.6618596 C9.3516211,9.90784267 9.01898991,10.0308324 8.64442479,10.0308324 C8.26985968,10.0308324 7.96518068,9.90784267 7.73037867,9.6618596 L1.05532626,2.98680719 C0.820524245,2.69609994 0.703125,2.36626396 0.703125,1.99728937 C0.703125,1.62831478 0.820524245,1.32084057 1.05532626,1.07485751 C1.33485246,0.840055495 1.66189322,0.72265625 2.03645833,0.72265625 C2.41102345,0.72265625 2.72129288,0.840055495 2.96727594,1.07485751 L8.68635351,6.81070656 L14.4054311,1.07485751 C14.6961383,0.840055495 15.0287695,0.72265625 15.4033346,0.72265625 C15.7778998,0.72265625 16.0825788,0.840055495 16.3173808,1.07485751 C16.4627344,1.22021113 16.5633623,1.3683578 16.6192676,1.51930195 C16.6751728,1.6702461 16.703125,1.84075453 16.703125,2.03083235 Z" />
  </svg>
</template>

<script>
  import { bem } from '@/mixins/bem.js'

  const namespace = 'svg-icon-caret-down'

  export default {
    name: 'SvgIconCaretDown',
    components: {},
    mixins: [ bem ],
    props: {
      height: {
        default: '10',
        type: String
      },
      width: {
        default: '17',
        type: String
      }
    },
    data () {
      return {}
    },
    computed: {
      getHeight: function () {
        const height = `${this.height}px`

        return height
      },
      getWidth: function () {
        const width = `${this.width}px`

        return width
      }
    },
    created: function () {
      this.namespace = namespace
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/svgs/SvgIconCaretDown.vue